/**
 * 性能相关常量配置
 * 集中管理，避免魔法数字散落各处
 */

// ============ 定时器延迟 ============
/** 联系人切换后舞台模型更新延迟（ms） */
export const STAGE_MODEL_UPDATE_DELAY = 150

/** 联系人切换标志重置延迟（ms） */
export const CONTACT_SWITCH_RESET_DELAY = 0

// ============ 超时配置 ============
/** AI 首次响应超时（ms） */
export const AI_FIRST_RESPONSE_TIMEOUT = 120000

/** AI 流式响应空闲超时（ms） */
export const AI_STREAM_IDLE_TIMEOUT = 30000

/** 记忆摘要生成超时（ms） */
export const MEMORY_DIGEST_TIMEOUT = 30000

// ============ IndexedDB 防抖 ============
/** 聊天记录写入防抖（ms） */
export const CHAT_STORAGE_DEBOUNCE = 500

/** 记忆系统写入防抖（ms） */
export const MEMORY_STORAGE_DEBOUNCE = 500

/** 联系人数据写入防抖（ms） */
export const CONTACTS_STORAGE_DEBOUNCE = 300

// ============ 上下文窗口 ============
/** Operit 式摘要后保留最近消息数（兜底） */
export const MAX_CONTEXT_MESSAGES_AFTER_SUMMARY = 1000

/** 内联摘要生成间隔（对话轮数） */
export const SUMMARY_GENERATION_INTERVAL = 20

// ============ 记忆系统 ============
/** 记忆相似度阈值（Jaccard） */
export const MEMORY_SIMILARITY_THRESHOLD = 0.8

/** 记忆去重长度差异阈值（倍数） */
export const MEMORY_LENGTH_RATIO_THRESHOLD = 4

// ============ 其他 ============
/** 防抖时未知 JSON 探测缓冲区大小（字符） */
export const JSON_PROBE_BUFFER_SIZE = 256

/** LLM Marker 最小字面量发射长度 */
export const MIN_LITERAL_EMIT_LENGTH = 24
